import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { entAnimations } from 'src/app/animations';
import { UserGraph } from 'src/app/models/user-graph.model';
import { GraphService } from 'src/app/services/graph/graph.service';
import { Error } from 'src/app/models/error.model';
import { UserTeamGraph } from 'src/app/models/user-team-graph.model';
import { LocalStorageService } from 'src/app/services/localStorage/localStorage.service';

@Component({
  selector: 'app-user-microsoft-profil',
  templateUrl: './user-microsoft-profil.component.html',
  styleUrl: './user-microsoft-profil.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class UserMicrosoftProfilComponent implements OnInit {
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  isBusyRetrieveMicrosoftInfo: boolean;
  userEmail: string;
  microsoftUser: UserGraph;
  microsoftTeamsUser: UserTeamGraph[];

  constructor(
    private _graphSerivce: GraphService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this.userEmail = params['email'];

      this.microsoftUser = this._localStorageService.getItem('microsoftUser');

      if (this.microsoftUser == null || !this.microsoftUser) {
        this.getMicrosoftUser();
      }

      if (
        this.microsoftUser &&
        this.microsoftUser.userPrincipalName != this.userEmail
      ) {
        this.refreshData();
      }
    });
  }

  getTeams(teams: UserTeamGraph[]) {
    this.microsoftTeamsUser = teams;
  }

  getReturnUrl() {
    this._router.navigate(['/support']);
  }

  refreshData() {
    this.microsoftUser = null;
    this._localStorageService.removeItem('microsoftUser');
    this._localStorageService.removeItem('microsoftTeamsUser');
    this._localStorageService.removeItem('microsoftGroupsUser');
    this.getMicrosoftUser();
  }

  async getMicrosoftUser() {
    try {
      this.isBusyRetrieveMicrosoftInfo = true;
      this.microsoftUser = await lastValueFrom(
        this._graphSerivce.getMicrosoftUserInfo(this.userEmail)
      );

      this._localStorageService.setItem('microsoftUser', this.microsoftUser);
    } catch (e) {
      let customError: Error = { error: undefined };
      if (e.error) {
        customError = JSON.parse(e.error);
      }
      if (customError.error !== undefined) {
        if (customError.error.code == 'ERR404') {
          this._router.navigate(['/errors/error-404']);
        }
      }
    } finally {
      this.isBusyRetrieveMicrosoftInfo = false;
    }
  }

  get userId() {
    return this.microsoftUser ? this.microsoftUser.id : undefined;
  }

  get sharedMailBoxes() {
    return this.microsoftUser ? this.microsoftUser.sharedMailBoxes : undefined;
  }

  get licenses() {
    return this.microsoftUser ? this.microsoftUser.licenses : undefined;
  }
}
